'use client';

/**
 * Invisible client island mounted on detail pages. Records the view in the
 * visitor model and notifies the world engine so the 3D layer can react.
 * Renders nothing; the page itself stays a pure server component.
 */

import { useEffect } from 'react';
import { useWorld } from '../../lab/store';
import { emitLabEvent } from '../../lab/events';

interface ViewTrackerProps {
  kind: 'project' | 'research';
  slug: string;
}

export default function ViewTracker({ kind, slug }: ViewTrackerProps) {
  useEffect(() => {
    const state = useWorld.getState();
    if (kind === 'project') {
      state.recordProject(slug);
      emitLabEvent({ type: 'PROJECT_OPENED', slug });
    } else {
      state.recordResearch(slug);
      emitLabEvent({ type: 'RESEARCH_OPENED', slug });
    }
  }, [kind, slug]);

  return null;
}
